import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useDropzone } from "react-dropzone";
import Header from '../Login/Header';
import UploadFile from "../Assets/Upload.svg";
import UploadAssetFile from "../Assets/upload_asset.svg";
import XtractIcon from '../Assets/XtractIcon.svg';
import SpiralIcon from '../Assets/SpiralIcon.svg';
import CloseBtn from '../Assets/Close.svg';
import PdfImg from '../Assets/pdf.svg';
import Logout from '../Assets/logout-svgrepo-com.svg';
import Back from '../Assets/back-svgrepo-com.svg';
import './style.css';
import { useNavigate } from 'react-router-dom';
import ResultPage from './Result';
import PdfViewer from '../PdfPage/FinalPdf';
import Xarrow, { useXarrow } from "react-xarrows";
import axios from 'axios';
import LoadingSpinner from './Loader';
import { MockData, MockJson } from './mockData';

function LandingPage() {
  const navigate = useNavigate();
  const [files, setFiles] = useState([]);
  const [ShowResult, setShowResult] = useState(false);
  const [FileURL, setFileURL] = useState('');
  const [FileName, setFileName] = useState('');
  const [highlightText, setHighlightText] = useState(null);
  const [arrowStart, setArrowStart] = useState(null);
  const [arrowEnd, setArrowEnd] = useState(null);
  const [endIndex, setEndIndex] = useState(null);
  const [IsLoading, setIsLoading] = useState(false);
  const [Data, setData] = useState([]);

  const updateXarrow = useXarrow(); // Hook to trigger arrow updates

  const pdfRef = useRef(null); // Reference for PdfViewer
  const resultRef = useRef(null); // Reference for ResultPage
  const resultContainerRef = useRef(null); 

  const handleRowClick = (text, rowId, indexId) => {
    setHighlightText(text);
    setArrowStart(rowId);
    setEndIndex(indexId);
  };

  const handleHighlightPosition = (highlightId) => {
    setArrowEnd(highlightId);
  };

  const handleBacktoUpload = () => {
    setFileURL('')
    setShowResult(false)
    setFiles([])
  }

  const onDrop = useCallback((acceptedFiles) => {
    setFiles(acceptedFiles.map(file => Object.assign(file, {
      preview: file
    })));
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const blob = new Blob([reader.result], { type: file.type });
        const url = URL.createObjectURL(blob);
        setFileURL(url);
        setFileName(file?.name)
        console.log(file, 'url')
      };
      reader.readAsArrayBuffer(file);
    });
  }, []);

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    maxFiles: 1,
    accept: ".pdf, .doc, .docx, .txt",
    noClick: true,
    noKeyboard: true,
  });

  const handleClose = () => {
    setFileURL('');
    setFiles([]);
  };

  const handleScroll = useCallback(() => {
    updateXarrow(); // Trigger arrow update on scroll
  }, [updateXarrow]);


  useEffect(() => {
    const pdfElement = pdfRef.current;
    const resultElement = resultContainerRef.current;
  
    if (pdfElement) {
      pdfElement.addEventListener('scroll', handleScroll);
    }
    if (resultElement) {
      resultElement.addEventListener('scroll', handleScroll);
    }
  
    // Cleanup on unmount
    return () => {
      if (pdfElement) {
        pdfElement.removeEventListener('scroll', handleScroll);
      }
      if (resultElement) {
        resultElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll]);

  
  // const handleXtract = async () => {
  //   setData(MockData);
  //   setShowResult(true);
    // try {
    //   setIsLoading(true);
    //   const formData = new FormData();
  
    //   if (typeof FileURL === 'string' && FileURL.startsWith('blob:')) {
    //     const response = await fetch(FileURL);
    //     const blob = await response.blob();
    //     formData.append("file", new File([blob], "uploaded_file.pdf", { type: 'application/pdf' }));
    //   } else if (FileURL instanceof File || FileURL instanceof Blob) {
    //     formData.append("file", FileURL, FileURL.name || 'extracted_file.pdf');
    //   }
  
    //   const { data } = await axios.post('http://127.0.0.1:8000/api/upload/', formData, {
    //     headers: { 'Content-Type': 'multipart/form-data' },
    //   });
  
    //   if (data?.process_result) {
    //     setData(data.process_result);
    //     setShowResult(true);
    //   } else {
    //     console.error("process_result is missing in the response:", data);
    //   }
    // } catch (error) {
    //   console.error("Error uploading file:", error);
    // } finally {
    //   setIsLoading(false);
    // }
  // };

  const handleXtract = async () => {
    // setData(MockData);
    // setShowResult(true);
    try {
      setIsLoading(true);

      const response = await fetch(FileURL);
      const blob = await response.blob();

      const formData = new FormData();
      formData.append("file", blob, FileName); // binary
      formData.append("filename", FileName);   // 👈 REQUIRED by Postman

      const apiResponse = await axios.post(
        // "http://139.59.34.172:8080/extract-blob",
        "http://159.89.167.172:8000/extract-blob",
        formData
      );

      console.log("API RESPONSE 👉", apiResponse.data);
      if(apiResponse.data){
        setData(apiResponse.data)
      }
      setShowResult(true);
    } catch (error) {
      console.error("UPLOAD FAILED ❌", error);
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div>
      <Header border={false} />
      <div className={`d-flex flex-wrap justify-content-between align-items-center px-5`} style={{ width: '100%', height: '6vh', background: '#0473ea',position:'relative', zIndex: '10'}}>
        <div className="mb-0" style={{ color: '#fff', fontSize: '13px', cursor: 'pointer' }}><span className='pe-2' onClick={()=>navigate('/Home')}>Home</span>| {ShowResult && <><span className='px-2' onClick={handleBacktoUpload}>Back to Upload</span>|</>}<span className='ps-2' style={{fontWeight: '600'}}>DocX</span></div>
        <p className="mb-0" style={{ color: '#fff', fontSize: '13px', fontWeight: '500', cursor: 'pointer' }} onClick={() => navigate('/')}><img src={Logout} className='me-2' width='25px' />Sign Out</p>
      </div>
      <div className="row p-0 m-0">
        {FileURL.length === 0 ? (
          <div className="col-6 dis-props" style={{ height: '80vh', borderRight: '1vh solid #F4F5F6' }}>
            <div id="empty-pdf" className="text-center d-flex flex-wrap justify-content-center">
              <img className="mb-2" src={UploadAssetFile} />
              <p style={{ width: '100%', color: '#7E8081', fontSize: '14px' }}>No file added to preview</p>
            </div>
            <div id="pdfViewer" style={{ height: '100%', width: '100%', display: 'none' }}></div>
          </div>
        ) : (
          <div className="col-6 px-0 dis-props pdf-scroll-none-all" ref={pdfRef}>
            <PdfViewer src={FileURL} highlightText={highlightText} onHighlightPosition={handleHighlightPosition} endIndex={endIndex} />
          </div>
        )}
        {!ShowResult ? (
           <div className='col-6 dis-props px-5' style={{height: '80vh', borderLight: '1vh solid #F4F5F6', overflowY: 'auto', background: '#EEF2F6'}}>
            { IsLoading ? <LoadingSpinner /> :
            <div id="upload-section" class="flex-wrap justify-content-center align-items-center" style={{display: 'flex',height: '80%',width: '95%',background: '#fff',borderRadius: '5px'}}>
                         {files.length > 0 ?  
                        <div class="flex-wrap justify-content-center align-items-center" style={{position: 'relative',height: '100%',width: '100%'}}>
                            <img src={CloseBtn} style={{position: 'absolute',top: '15px',right: '15px', zIndex: '999',cursor: 'pointer'}} width="16" onClick={handleClose} />
                          <div class="d-flex flex-wrap justify-content-center align-items-center" style={{height: '100%'}}>
                            <div>
                            <img class="mb-3" src={PdfImg} />
                            <p class="text-center justify-content-center mb-2" style={{fontSize: '14px',fontWeight: '700',width: '100%'}}>{files[0].path}</p>
                            <p class="text-center" style={{fontSize: '12px',color: '#A09FA1',width: '100%'}}>{files[0].size}</p>
                            <button className="blueButton" style={{padding: '6px 20px 8px 20px'}} type="button" onClick={handleXtract}>
                                <img src={XtractIcon} width="40" />
                            </button>
                            <div className='pt-4' style={{fontSize: '14px', color: '#0473ea', cursor: 'pointer'}} onClick={handleBacktoUpload}>Back to upload</div>
                            </div>
                          </div>
                        </div> :
                        <div id="file-upload-div" class="dash-box d-flex flex-wrap justify-content-center align-items-center" {...getRootProps()}>
                        <input {...getInputProps()} />
                        <div id="drop-area" class="flex-wrap justify-content-center align-items-center">
                            <img class="mb-3" src={UploadFile} />
                            <h1 style={{fontSize: '14px',fontWeight: '700',width: '100%'}}>Drag & Drop Your Files Here</h1>
                            <p style={{fontSize: '12px',color: '#A09FA1',fontWeight: '500',width: '100%'}}>Supports pdf, doc, docx, txt</p>
                            <input type="file" id="fileInput" style={{display: 'none'}} />
                            <button className="blueButton" style={{padding: '7px 18px'}} onClick={open} type="button">
                              Browse File
                            </button>
                        </div>
                        </div>
                        }
          </div>}
        </div>
        ) : (
          <div className="col-6 dis-props px-3" style={{ height: '80vh' }} >
            <ResultPage ref={resultContainerRef} handleStatus={setShowResult} handleRowClick={handleRowClick} Data={Data} MockJson={MockJson}/>
          </div>
        )}
        {arrowStart && arrowEnd && (
          <Xarrow
            start={arrowStart}
            end={arrowEnd}
            color="CornflowerBlue"
            headShape="circle"
            arrowHeadProps={{"fill": "transparent",
              "strokeWidth": "0.1",
              "stroke": "CornflowerBlue"}}
            tailShape="circle"
            arrowTailProps={{"fill": "transparent",
              "strokeWidth": "0.1",
              "stroke": "CornflowerBlue"}}
            animateDrawing={0.3}
            showTail
            strokeWidth={1}
            curveness={0.3}
            zIndex={9}
          />
        )}
      </div>
      <div className="d-flex flex-wrap justify-content-center align-items-center px-4" style={{ height: '6vh', borderTop: '1px solid #d5d5d5', position: 'relative', zIndex: '10'}}>
        <p className="text-end mb-0" style={{ fontSize: '12px', width: '100%', color: '#9e9c9c' }}>© 2025 All rights reserved by <img src={SpiralIcon} width="70" /></p>
      </div>
    </div>
  );
}

export default LandingPage;
